$(document).ready(function () {
  var NAVIGATION_BASE = ".article-navigation";
  var NAVIGATION_TEMPLATE = ".article-navigation-template";
  var NAVIGATION_CONTENT = '.article-description h2';

  var $target = $(NAVIGATION_BASE);
  if ($target.length) {
    var template = Handlebars.compile($(NAVIGATION_TEMPLATE).html());
    var list = [];
    var uid = 0;
    $(NAVIGATION_CONTENT).each(function (i, item) {
      var $item = $(item);
      list.push({
        'title': $item.text(),
        'link': 'article-header-' + uid
      });
      uid += 1;
    }).promise().done(function () {
      if (list.length > 1) {
        var output = template({
          'items': list
        });
        $target.html(output);

        // Due to IE issues these have to be added afterwards. Otherwise IE doesn't see them in the
        // DOM and it fails to click through.
        var articleId = 0;
        $(NAVIGATION_CONTENT).each(function (i, item) {
          var $item = $(item);
          $('<a name="article-header-' + articleId + '"></a>').insertBefore($item);
          articleId += 1;
        });
      }
    });
  }
});